// Place scripts that must be run in the <head> here.
// console.log('hello from nawi-head.js');